import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Paging, { ToPage, GetParams } from "@component/UI/Paging";

import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const location = useLocation();
    const code = "photo";

    const { site, iam } = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [list, setList] = useState([]);
    const [paging, setPaging] = useState(null);
    const [searchInfo, setSearchInfo] = useState({
        keyword: null,
        page: 1,
    });

    const loadList = (data) => {
        _API.get({ path: "/site/bbs", data: { ...data, code } })
            .then((res) => {
                const { list, paging } = res.data;
                setList(list);
                setPaging(paging);
                setIsLoading(false);
            })
            .catch((e) => {
                _API.alert({ message: e.message });
            });
    };

    const onKeyDown = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };

    const movePage = (page) => {
        ToPage(location, navigate, { ...searchInfo, page });
    };

    const onSearch = (key, value) => {
        ToPage(location, navigate, { ...searchInfo, page: 1 });
    };

    useEffect(() => {
        if (code) {
            setIsLoading(true);
            const params = GetParams(location);
            if (params) {
                setSearchInfo(params);
                loadList(params);
            } else {
                setSearchInfo({
                    keyword: null,
                    page: 1,
                });
                loadList({
                    keyword: null,
                    page: 1,
                });
            }
        }

        return () => {
            setList([]);
            setPaging(null);
        };
    }, [location, code]);

    let virtualNo = paging ? paging.virtualRecordNo : -1;

    return (
        <Fragment>
            {isLoading && <Loading />}
            <div className="contents">
                {site?.naviBbsPhoto && parse(site?.naviBbsPhoto)}

                <div className="right">
                    <div className="contentsTop">
                        <h3>Photo Gallery</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Photo Gallery</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <div className="clear_float mgt50">
                            <div className="box_search">
                                <input
                                    type="text"
                                    name="keyword"
                                    placeholder="Keyword"
                                    value={searchInfo?.keyword}
                                    onChange={(e) => setSearchInfo({ ...searchInfo, keyword: e.target.value })}
                                    onKeyDown={onKeyDown}
                                />
                                <button className="btn1 btn_blue1" onClick={onSearch}>
                                    Search
                                </button>
                            </div>
                            <p className="board_count">Total : {paging?.totalSize || 0}</p>
                        </div>

                        <div className="list_gallery">
                            {list?.map((item, index) => (
                                <a href={`/bbs/${item.code}/${item.idx}`} key={index}>
                                    <span className="img">{item.signedUrl && <img src={item.signedUrl} alt="" />}</span>
                                    <span className="txt ellipsis">{item.title}</span>
                                </a>
                            ))}
                        </div>
                        {paging && <Paging paging={paging} pageCallback={movePage} type="FRONT" />}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
